import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { SharedModule } from "@app/shared/shared.module";
import { WorkdayOrganizerDataService } from "./services/workday-organizer-data.service";
import { WorkdayOrganizerComponent } from "./workday-organizer.component";
import { WorkingDaysComponent } from "./components/working-days/working-days.component";
import { HolidaysDaysoffComponent } from "./components/holidays-daysoff/holidays-daysoff.component";
import { CerrixButtonComponent } from "@app/shared/atoms/cerrix-button/cerrix-button.component";
import { CerrixPageFooterComponent } from "@app/shared/cerrix-page-footer/cerrix-page-footer.component";

@NgModule({
    exports: [],
    imports: [
        CommonModule,
        SharedModule,
        WorkingDaysComponent,
        HolidaysDaysoffComponent,
        CerrixPageFooterComponent,
        CerrixButtonComponent,
        WorkdayOrganizerComponent,
    ],
})
export class WorkdayOrganizerModule {
    static forRoot(): ModuleWithProviders<WorkdayOrganizerModule> {
        return {
            ngModule: WorkdayOrganizerModule,
            providers: [WorkdayOrganizerDataService],
        };
    }
}
